var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "om-circle-progress",
    style: _vm.style
  }, [_c('svg', {
    attrs: {
      "viewBox": `0 0 ${_vm.svgViewBoxSize} ${_vm.svgViewBoxSize}`
    }
  }, [_c('path', {
    style: _vm.pathStyle,
    attrs: {
      "d": _vm.path,
      "fill": "none"
    }
  }), _c('path', {
    style: {
      strokeWidth: `${_vm.strokeWidth}px`,
      strokeLinecap: _vm.strokeLinecap,
      strokeDasharray: `${_vm.perimeter}px`,
      strokeDashoffset: _vm.strokeDashoffset,
      transition: _vm.useTransition && (_vm.animationState === 'paused' ? 'none' : 'stroke-dashoffset 0.1s linear')
    },
    attrs: {
      "d": _vm.path,
      "stroke": _vm.conicGradient ? 'url(#gradient)' : _vm.color,
      "fill": "none"
    }
  }), _vm.conicGradient ? _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "gradient",
      "x1": "100%",
      "y1": "0%",
      "x2": "0%",
      "y2": "0%"
    }
  }, _vm._l(_vm.conicGradient, function (item, index) {
    return _c('stop', {
      key: index,
      attrs: {
        "offset": item.offset,
        "stop-color": item.color
      }
    });
  }), 1)], 1) : _vm._e()]), _vm.$slots.default ? _c('div', {
    staticClass: "om-circle-progress__content"
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };